export const pingInitialState = {
  ping: true
};

export const pingActions = {
  SET_PING: (state: any, payload: boolean) => {
    return { ...state, ping: payload };
  }
};
